import { createContext, useContext, useEffect, useState } from "react";
import api, { setUnauthorizedHandler } from "@/lib/api";
import { applyLang } from "@/lib/i18n";

const Ctx = createContext(null);
export const useApp = () => useContext(Ctx);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [booting, setBooting] = useState(true);
  const [lang, setLangState] = useState(() => localStorage.getItem("hl_lang") || "bi");
  const [search, setSearch] = useState("");
  const [branding, setBranding] = useState({ companyName: "PT HONGLU BAJA INDONESIA", tagline: "", logoDataUrl: null });

  const refreshBranding = () => api.get("/branding").then((r) => setBranding(r.data)).catch(() => {});

  useEffect(() => { applyLang(lang); }, [lang]);
  useEffect(() => { const t = setTimeout(() => applyLang(lang), 300); return () => clearTimeout(t); }, [user, lang]);

  useEffect(() => {
    if (branding.companyName) document.title = `${branding.companyName} — Fabrikasi & Delivery Control`;
    if (branding.logoDataUrl) {
      let link = document.getElementById("app-favicon");
      if (!link) { link = document.createElement("link"); link.id = "app-favicon"; link.rel = "icon"; document.head.appendChild(link); }
      link.type = branding.logoDataUrl.startsWith("data:image/svg") ? "image/svg+xml" : "image/png";
      link.href = branding.logoDataUrl;
    }
  }, [branding]);

  useEffect(() => {
    api.get("/auth/me")
      .then((d) => setUser(d.data))
      .catch(() => setUser(null))
      .finally(() => setBooting(false));
    setUnauthorizedHandler(() => setUser(null));
    refreshBranding();
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(null);
  };

  const setLang = (v) => { setLangState(v); localStorage.setItem("hl_lang", v); };

  return (
    <Ctx.Provider value={{ user, setUser, booting, login, logout, lang, setLang, search, setSearch, branding, refreshBranding }}>
      {children}
    </Ctx.Provider>
  );
}